import React from "react";
import SectionHeading from "./SectionHeading";
import { LANDING } from "@/constants/testIds";

const FEATURES = [
  "Asset-backed senior secured loans",
  "Unitranche & stretched-senior facilities",
  "Pre-event bridge & rescue financings",
  "Recapitalisation & refinancing solutions",
  "Covenant-led structures with downside protection",
  "Equity-linked enhancements where appropriate",
];

const CreditBridge = () => {
  return (
    <section
      data-testid={LANDING.creditBridge}
      className="relative py-32 lg:py-44 border-t border-[var(--kr-line-soft)] overflow-hidden"
    >
      {/* Background industrial photo */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-[0.10]"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&w=2400&q=70')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%) contrast(1.1)",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, var(--kr-bg) 0%, transparent 30%, transparent 70%, var(--kr-bg) 100%)",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <SectionHeading
            index="06"
            label="Industrial Credit & Bridge Capital"
            title={
              <>
                Senior-secured.
                <br />
                Collateralised.{" "}
                <span className="italic text-[var(--kr-gold)]">
                  Cash-flow underwritten.
                </span>
              </>
            }
          />
        </div>
        <div className="lg:col-span-6 lg:pl-10">
          <p className="text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[58ch] mb-12">
            The credit platform is in strategy preparation across senior-secured
            term financings, unitranche structures and time-sensitive bridge
            facilities to lower- and mid-market industrial operators. Each
            prospective transaction is intended to be underwritten against
            tangible collateral, contracted revenue streams and a defined path
            to refinancing or capital event.
          </p>

          <ul className="grid sm:grid-cols-2 gap-x-10 gap-y-5">
            {FEATURES.map((f) => (
              <li
                key={f}
                className="flex items-start gap-3 text-[var(--kr-text)] text-[15px] leading-[1.6]"
              >
                <span
                  aria-hidden
                  className="mt-[10px] block w-[6px] h-[6px] flex-shrink-0"
                  style={{
                    background: "var(--kr-gold)",
                    transform: "rotate(45deg)",
                  }}
                />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CreditBridge;
